/**
 * Public HTTP API version and path constants shared by dentexe-api, web, and mobile.
 * Bump {@link API_VERSION} and add a new router mount when shipping breaking changes.
 */
export const API_VERSION = 'v1' as const;

/** REST prefix without leading slash (e.g. `api/v1`). */
export const API_PATH_PREFIX = `api/${API_VERSION}` as const;

/** Unversioned health probe path for load balancers. */
export const HEALTH_HTTP_PATH = '/health' as const;

/**
 * Relative direct-upload URL returned to clients (browser PUT).
 * @param {string} fileId - Media file identifier in the upload route
 * @param {string} uploadToken - Short-lived token appended as a query parameter
 * @returns {string} Versioned path such as `/api/v1/media/upload/{fileId}?token=…`
 */
export function buildMediaUploadPath(fileId: string, uploadToken: string): string {
  return `/${API_PATH_PREFIX}/media/upload/${fileId}?token=${encodeURIComponent(uploadToken)}`;
}
